import React, { useEffect, useState } from "react";
import { Typography } from "@material-ui/core";
import { Box, IconButton, Tooltip, Grid} from '@mui/material';
import { useMemo } from 'react';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { useTheme } from "@material-ui/core/styles";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getPlanningDataByDistrict } from "services/dsc";
import { initialSelections } from "./constants";
import DropDowns from "./DropDowns";
import { useDSCStyles } from "./styles";
import {analytics} from 'services/firebase';
import { ADD_EDIT_EMPLOYEE_DSC} from '../../../navigation/CONSTANTS';

export default function DSCEmployeeLevelPlanning() {
  const { t } = useTranslation();
  const classes = useDSCStyles();
  const theme = useTheme();
  const { user } = useSelector((state) => state.user.auth);
  const [isLoading, setIsLoading] = React.useState(false);
  const [selections, setSelections] = React.useState(initialSelections);
  const [loading, setLoading] = React.useState(true);
  const [planList, setPlanList] = useState([]);
  const [primary, setPrimary] = useState(null);
  
  const reportTheme = createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: 10,
        },
      },
      MuiButton: {
        textPrimary: {
          color: "#1B75BC",
        },
      },
      MuiTypography: {
        body2: {
          color: "#1B75BC",
        },
      },
      MuiInputLabel: {
        root: {
          "&$focused": {
            color: "#1B75BC",
          },
        },
      },
      MUIDataTableToolbar: {
        iconActive: {
          color: "#1B75BC",
        },
        icon: {
          "&&:hover": {
            color: "#1B75BC",
          },
        },
      },
      MuiChip: {
        label: {
          color: "#1B75BC",
        },
        deleteIcon: {
          color: "#1B75BC",
        },
      },
      MuiCheckbox: {
        colorPrimary: {
          "&$checked": {
            color: "#1B75BC",
          },
        },
      },
      MuiInput: {
        underline: {
          "&&:after": {
            borderBottom: "2px solid #1B75BC",
          },
        },
      },
    },
  });

  const columns = useMemo(
    () => [
      {
        accessorKey: 'name', //access nested data with dot notation
        header: 'Name',
        size: 150,
      },
      {
        accessorKey: 'districtId',
        header: 'District Id',
        size: 150,
      },
      {
        accessorKey: 'primaryBuilding', //normal accessorKey
        header: 'Primary Building',
        size: 200,
      },
      {
        accessorKey: 'productivityHrs',
        header: 'Productivity Hrs',
        size: 150,
      },
      {
        accessorKey: 'weekStartDate',
        header: 'Week StartDate',
        size: 150,
      },
      
      // {
      //   header: 'More Info Links',
      //   accessorKey: 'link',
      //   disableFilters: true,
      //   enableGlobalFilter: false,
        
      //   Cell: ({ cell, planList }) => (
      //     <Link href={"href"} passHref legacyBehavior>
      //       <MuiLink
             
      //         target={
      //           "trst"
      //             ? '_blank'
      //             : undefined
      //         }
      //         rel="noopener"
      //       >
      //         {planList.original?.linkText}
      //       </MuiLink>
      //     </Link>
      //   ),
      // },
    ],
    [],
  );
  useEffect(()=>{
    if(user.workerId){
      analytics.logEvent('imtime_dsc_employee_level_planning_list_page_visited',{
        userId:user?user.workerId:"",
        userName:user.firstName+" "+user.lastName,
        userCountry:user.country?user.country:""
      })
    }
  },[user])

  

  const getDate = (dayNum=0) =>{
    return moment(selections.week).startOf("week").add(dayNum, "days").format("DD");
  }

 
  async function fetchPlanningData() {
    console.log("fetchPlanningData", primary);
    setLoading(true);
    if (!primary || !selections.district || !selections.week) {
      return;
    }

    try {
      const plans = await getPlanningDataByDistrict(
        selections.district,
        selections.week
      );
      setPlanList(plans);
      setLoading(false);
      setIsLoading(false);
      console.log("fetchPlanningData Data", planList);
    } catch (e) {
      setPlanList([]);
      setLoading(false);
      console.log(e);
    }
  }

  
  const handleLoadClick = async () => {
    setPlanList([]);
    //EventEmitter.dispatch("clearSelectedPlan", { prevPlan: null });
    if (!primary) {
      //setActivities([]);
      setLoading(false);
      return;
    }
    if (selections.week && selections.district ) {
      
      await fetchPlanningData();
    }
  };

  
  const handleSelectionsChange = (selection) => {
    setSelections(selection);
    console.log(selection);
  };


  const handlePrimaryChange = async (newPrimary) => {
    console.log("handlePrimaryChange", newPrimary);
   
    setPlanList([]);
    setPrimary(newPrimary);
  };

  React.useEffect(() => {

    handleLoadClick();
    
  }, [primary, selections.week]);

  const data = planList;
 
  const table = useMaterialReactTable({
    columns,
    data, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    enableRowActions: true,
    enablePagination: true,
    state:{
      isLoading: loading
    },
    initialState: {
      columnPinning: {
        right: ['mrt-row-actions'],
      },
      pagination: { pageSize: 50, pageIndex: 0  }
    },
    muiTableContainerProps: {
      sx: {
        height : `calc(100vh - 300px)`,
      //  maxHeight : "100%"
      }
    },
    renderRowActions: ({ row, table }) => (
      
      <Box sx={{ display: 'flex', gap: '1rem' }}>
       
        <Tooltip title="View">
          <IconButton color="error" >
          <Link
                to={{
                    pathname: `${ADD_EDIT_EMPLOYEE_DSC}`,
                    search: `?districtId=${row.original.districtId}&buildingId=${row.original.primaryBuilding}&week=${selections.week}`,
                    state: {planData: row.original}
                 }}
              onClick = {() => {
                console.log("renderRowActions", row);
              }}   
            >
                <Typography >View</Typography>
            </Link>
          </IconButton>
        </Tooltip>
      </Box>
    ),
    renderTopToolbarCustomActions: ({table}) =>(
      <Grid container style={{gap : "20px", alignItems: "flex-end", margin:"0 20px 0 20px", justifyContent: "space-between"}}>
      <Typography variant='h6'>
         DSC Plans
      </Typography>
      </Grid>
    )
  });
  return (
    <div className={classes.root}>
        <div style={{display:'flex', justifyContent:'space-between'}}>
          <DropDowns
            onChangeSelections={handleSelectionsChange}
            //onChangeAverage={handleAverageChange}
            onChangePrimary={handlePrimaryChange}
            onClickLoad={handleLoadClick}
            loading={loading}
            setLoading={setLoading}
            existingPlans={setPlanList}
           
          />
         
        </div>

        <div style = {{marginTop:"20px"}}>
            <MuiThemeProvider theme={reportTheme}>
                <MaterialReactTable table={table}
               />
            </MuiThemeProvider>
        </div>
    </div>
  );
}
